export const createGradient = (color1: string, color2: string): string =>
  `linear-gradient(to bottom, ${color1}, ${color2})`;
